import React from 'react'
import Footer from './Footer'
import HomeSection from './HomeSection'

function About() {
  return (
    <div>
        <HomeSection/>
        <Footer/>
    </div>
   
  )
}

export default About